<template>
  <local-map-page class="full-height"
                  :organisation-boundaries="organisationBoundaries"
                  :filtered-boundaries="filteredBoundaries"
                  :search-strategy="searchStrategy"
                  :url-filter-keys="urlFilterKeys"
                  :initial-searched-location="initialSearchedLocation" />
</template>

<script>
import LocalMapPage from './local-map-page'
import { sharedMapPropsMixin } from './shared-map-props'
import { FILTER_KEY_BOUNDARY_BOX, FILTER_KEY_CALENDARS, FILTER_KEY_LOCATION, FILTER_KEY_TYPES } from './filter-keys'

export default {
  components: { LocalMapPage },

  mixins: [sharedMapPropsMixin],

  props: {
    initialSearchedLocation: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      urlFilterKeys: [FILTER_KEY_CALENDARS, FILTER_KEY_LOCATION, FILTER_KEY_TYPES, FILTER_KEY_BOUNDARY_BOX]
    }
  }
}
</script>

<style lang="scss" scoped>
.full-height{
  height: 100vh;
}
</style>
